type Size = "sm" | "md" | "lg";

export function Skeleton({ className = "", lines = 1, size = "sm" }: { className?: string; lines?: number; size?: Size }) {
  const items = Array.from({ length: Math.max(1, lines) });
  const h = size === "lg" ? "h-5" : size === "md" ? "h-4" : "h-3";
  return (
    <div className={`space-y-2 ${className}`}>
      {items.map((_, i) => (
        <div key={i} className={`${h} w-full animate-pulse rounded bg-muted/20`} />
      ))}
    </div>
  );
}
